import React from "react";
import { Paper, Typography } from "@mui/material";
import { PageHeader, EmptyState, EMPTY_KIND } from "../components/ui";

// A destination that exists in the navigation but has no content yet. It says
// so in the product's own not-implemented wording rather than as a bare card,
// so it cannot be mistaken for a page that failed to load.
export default function PlaceholderPage({ title, note }) {
  return (
    <>
      <PageHeader title={title} />
      <Paper variant="outlined" sx={{ borderRadius: 3 }}>
        <EmptyState kind={EMPTY_KIND.notImplemented} subject={String(title || "this").toLowerCase()} />
        {note && (
          <Typography sx={{ px: 3, pb: 3, mt: -3, textAlign: "center", color: "text.secondary" }}>
            {note}
          </Typography>
        )}
      </Paper>
    </>
  );
}
